import { getLogLevel } from "@/utils/get-log-level";
import { logger, LoggingLevel } from "@/utils";
import * as z from "zod";
import { LoggerFields } from "@/utils/logger/types";

export const helmValidation = <T, J>(
  data: T,
  schema: z.Schema<J>,
  confName: string,
  errorType = LoggerFields.Critical,
) => {
  try {
    schema.parse(data);
  } catch (err: z.ZodError | unknown) {
    if (err instanceof z.ZodError) {
      if (
        getLogLevel() > LoggingLevel.Information ||
        getLogLevel() === LoggingLevel.All
      ) {
        logger.group(`%c success: false, config: ${confName} `, "color:red");
        err.issues.forEach(e => {
          logger[errorType as keyof typeof logger](
            `${e.path.join(" - ")} : ${e.message}`,
          );
        });
        logger.groupEnd();
      }

      return { success: false, error: err.issues };
    }

    return { success: false, error: [err] };
  }

  if (getLogLevel() < LoggingLevel.Information) {
    logger.log(`%c success: true, config: ${confName} `, "color:green");
  }

  return { success: true, config: confName };
};
